import React, { useState, useEffect } from 'react';
import ChatView from './ChatView';
import { getVideoIndex } from '../firebase/catalog';
import { reportError } from '../monitoring';

/**
 * Open Search — the default surface: one question, the whole sermon archive.
 * Thin wrapper: loads the sermon catalog (for clickable timestamp titles) and
 * configures the shared ChatView for retrieval mode. An arrival from an ad
 * (`landing`, `prefill`) lands here. This is the front page: its "Ask
 * anything." types out (`typeOn`), the caret then waits in the box, and the
 * box says what to do with it.
 */
function FullArchiveChat({ user, chatId, resetNonce = 0, landing = null, prefill = null, fromAd = false, onRequestSignIn, onDirtyChange, onChatSaved, onAnswerComplete }) {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getVideoIndex()
      .then((list) => { if (!cancelled) setVideos(list.filter((v) => v?.videoUrl)); })
      .catch((err) => reportError(err, { where: 'catalog.load' }));
    return () => { cancelled = true; };
  }, []);

  return (
    <ChatView
      mode="archive"
      endpoint="chatWithGrokCollections"
      user={user}
      chatId={chatId}
      resetNonce={resetNonce}
      videos={videos}
      videoIds={[]}
      chatType="collections"
      draftKey="apr-draft-archive"
      placeholder="Type your question here"
      followupPlaceholder="Ask a follow-up…"
      landing={landing}
      prefill={prefill}
      fromAd={fromAd}
      welcome={{
        title: 'Ask anything.',
        text: 'AI-assisted answers, drawn from Pastor Rob’s own sermons, with a link to where he said it. A real person from The Net is here when you want one.',
        starters: true,
        typeOn: true,
      }}
      onRequestSignIn={onRequestSignIn}
      onDirtyChange={onDirtyChange}
      onChatSaved={onChatSaved}
      onAnswerComplete={onAnswerComplete}
    />
  );
}

export default FullArchiveChat;
